var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{attrs:{"type":"card"},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"报销列表","name":"depmana"}},[_c('Reimbus')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }